import { I18n } from '@calendly/i18n'
import { IconBuildings } from '@calendly/ui/components/glyphs/IconBuildings'
import { BodyText } from '@calendly/ui/components/typography'
import { UiIcon } from '@calendly/ui/components/ui-icon'

import { RECAP_ACCESS_LEVELS } from 'features/recaps/constants'
import { useRecapShare } from 'features/recaps/meeting_list/meeting_card/recap_share_context'

import {
  OrganizationPermissionSelect,
  PermissionSelectReadOnly,
  getRelationLabel,
} from './permission_select'
import {
  AccessListItem,
  AccessListItemContent,
  AccessListItemText,
  accessListItemTextLineCss,
  OrganizationIconContainer,
  organizationListItemContentCss,
} from './styles'

export const OrganizationAccessListItem = () => {
  const {
    accessLevel: { value: accessLevel },
    accessList: { organization, owner },
    currentUser,
    permissionUpdates: {
      getOrganizationRelation,
      setPendingOrgPermission,
    },
  } = useRecapShare()

  const isRestricted = accessLevel === RECAP_ACCESS_LEVELS.RESTRICTED
  const isOwner = currentUser?.uuid === owner?.uuid
  const organizationRelation = getOrganizationRelation(organization?.relation ?? null)

  const renderAction = () => {
    if (!isRestricted) {
      return (
        <PermissionSelectReadOnly
          label={I18n.t('publisher.meeting_recap.share_modal.access_list.permission_select.hidden')}
          testId="access-list-organization-permission"
        />
      )
    }

    // Non-owners cannot edit organization permission, show read-only view
    if (!isOwner) {
      const label = organizationRelation
        ? getRelationLabel(organizationRelation)
        : I18n.t('publisher.meeting_recap.share_modal.access_list.permission_select.hidden')

      return (
        <PermissionSelectReadOnly
          label={label}
          testId="access-list-organization-permission-readonly"
        />
      )
    }

    return (
      <OrganizationPermissionSelect
        value={organizationRelation}
        onChange={setPendingOrgPermission}
        onRemove={() => setPendingOrgPermission(null)}
      />
    )
  }

  return (
    <AccessListItem data-testid="access-list-organization">
      <AccessListItemContent className={organizationListItemContentCss}>
        <OrganizationIconContainer>
          <UiIcon icon={IconBuildings} size="medium" title="" />
        </OrganizationIconContainer>
        <AccessListItemText>
          <BodyText className={accessListItemTextLineCss}>
            {I18n.t('publisher.meeting_recap.share_modal.access_list.general_access.organization')}
          </BodyText>
        </AccessListItemText>
      </AccessListItemContent>
      {renderAction()}
    </AccessListItem>
  )
}
